export default () => ({
    isOpen: false,
    menu: null,
    subMenu: null,
    openDropdowns: {},
    toggle(show) {
        if (show) {
            this.isOpen = show;
            window.dispatchEvent(new CustomEvent('header-scrolled'));
        }
        else {
            this.isOpen =  !this.isOpen;
        }

        if (!this.isOpen) {
            this.subMenu = null;
            this.menu = null;
            this.openDropdowns = {};
        } 

    },
    setMenu(index) {
        this.menu = index;
    },
    setSubMenu(index) {
        this.subMenu = index;
    },
    toggleDropdown(dropdownId) {
        this.openDropdowns[dropdownId] = !this.openDropdowns[dropdownId];
    },
    isDropdownOpen(dropdownId) {
        return this.openDropdowns[dropdownId] || false;
    }
});